var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoDescargaCorreos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_descarga_correos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27510",
    "data-name": "Rect\\xE1ngulo 27510",
    width: 25,
    height: 25,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24184",
    "data-name": "Grupo 24184",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_14",
    "data-name": "Uni\\xF3n 14",
    d: "M9625.692-4898.434l-1.088-1.088a.431.431,0,0,1-.133-.316.432.432,0,0,1,.133-.317.438.438,0,0,1,.314-.13.449.449,0,0,1,.319.13l.318.319v-2.714a.45.45,0,0,1,.447-.45.448.448,0,0,1,.447.45v2.722l.329-.327a.44.44,0,0,1,.316-.13.447.447,0,0,1,.316.13.442.442,0,0,1,.131.317.441.441,0,0,1-.131.316l-1.09,1.088a.438.438,0,0,1-.314.13A.437.437,0,0,1,9625.692-4898.434Zm1.588-2.066.01-.053a.452.452,0,0,1-.262-.409.456.456,0,0,1,.293-.423v-.039h1.945a.523.523,0,0,0,.522-.522v-6.492a.523.523,0,0,0-.522-.522h-11.52a.523.523,0,0,0-.521.522v6.492a.523.523,0,0,0,.521.522h6.787v.063a.438.438,0,0,1,.264.4.441.441,0,0,1-.264.4v.061h-6.787a1.448,1.448,0,0,1-1.445-1.446v-6.492a1.448,1.448,0,0,1,1.445-1.445h11.52a1.448,1.448,0,0,1,1.448,1.445v6.492a1.449,1.449,0,0,1-1.448,1.446Zm.957-2.151-2.2-1.967-2.238,1.972a.451.451,0,0,1-.3.114.455.455,0,0,1-.308-.116l-2.17-1.936-2.2,1.938a.463.463,0,0,1-.3.114.465.465,0,0,1-.346-.152.473.473,0,0,1-.116-.338.461.461,0,0,1,.155-.314l2.119-1.866-2.119-1.9a.455.455,0,0,1-.155-.321.463.463,0,0,1,.116-.331.48.48,0,0,1,.319-.152h.012a.472.472,0,0,1,.324.118l4.677,4.179,4.749-4.182a.453.453,0,0,1,.3-.116.466.466,0,0,1,.348.155.469.469,0,0,1,.114.333.45.45,0,0,1-.155.319l-2.119,1.868,2.122,1.9a.458.458,0,0,1,.152.317.459.459,0,0,1-.116.333.457.457,0,0,1-.344.155A.454.454,0,0,1,9628.237-4902.652Zm-12.791.036a1.449,1.449,0,0,1-1.445-1.448v-6.489a1.449,1.449,0,0,1,1.445-1.448h11.52a1.448,1.448,0,0,1,1.445,1.448v.244l-.024,0a.46.46,0,0,1-.439.327.454.454,0,0,1-.431-.3h-.026v-.119l-.015-.024.013-.039v-.083a.529.529,0,0,0-.522-.534h-11.52a.524.524,0,0,0-.521.525v6.489a.523.523,0,0,0,.521.524h.522v.034a.456.456,0,0,1,.3.428.457.457,0,0,1-.3.428v.026l-.152.007Z",
    transform: "translate(-9609.856 4918.528)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31270",
    "data-name": "Trazado 31270",
    d: "M12.5,1A11.5,11.5,0,1,1,1,12.5,11.513,11.513,0,0,1,12.5,1m0-1A12.5,12.5,0,1,0,25,12.5,12.5,12.5,0,0,0,12.5,0",
    fill: "#d5007f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDescargaCorreos);
export default __webpack_public_path__ + "static/media/Icono_descarga_correos.8df3b19cd18255921fadc4eb357a8380.svg";
export { ForwardRef as ReactComponent };